<template>
  <div class="component-container">
    <div class="title">安全设置</div>
    <div class="account-box">
      <div class="name">您当前的账号安全程度</div>
      <div class="progress-box">
        <el-progress
          :text-inside="true"
          :stroke-width="20"
          :percentage="dataInfo.percentage"
          color="#1082FF"
          :show-text="false"
        ></el-progress>
      </div>
      <div class="security-box">
        <span class="security-level">安全级别：</span>
        <span class="level">{{ dataInfo.safeLevelName }}</span>
        <span class="state">继续努力</span>
      </div>
    </div>
    <div class="item-box">
      <div class="item-left">
        <div class="item-img">
          <img class="image" src="@/assets/icon_login_pwd.png" />
        </div>
        <div class="name">登录密码</div>
        <div class="desc">
          安全性高的密码可以使账号更安全。建议您定期更换密码，设置一个包含字母，符号或者数字中至少两项且长度超过6位的密码。
        </div>
      </div>
      <div class="state" @click="onSettingClick">设置</div>
    </div>
    <div class="item-box">
      <div class="item-left">
        <div class="item-img">
          <img class="image" src="@/assets/icon_verify_phone.png" />
        </div>
        <div class="name">验证手机</div>
        <div class="desc">
          您已绑定了手机{{
            dataInfo.phone
          }}[您的手机为安全手机，可以找回密码，可以用于登录]。
        </div>
      </div>
      <div class="state" @click="onEditClick">修改</div>
    </div>
    <login-password :dialogVisible.sync="loginPasswordVisible" />
    <change-phone :dialogVisible.sync="changePhoneVisible" />
  </div>
</template>
<script>
import LoginPassword from "./loginpassword.vue";
import ChangePhone from "./changephone.vue";
import { getCustomerSafe } from "@/api/accountcenter";
import { cookieKeys, getCookieItem } from "@/utils/auth.js";
import { getTel } from "@/utils/index.js";
export default {
  name: "SecuritySettings",
  components: {
    LoginPassword,
    ChangePhone,
  },
  data() {
    return {
      loginPasswordVisible: false,
      changePhoneVisible: false,
      dataInfo: {},
    };
  },
  mounted() {
    this._getCustomerSafe();
    this.dataInfo = {
      ...this.dataInfo,
      phone: getTel(getCookieItem(cookieKeys.phone)),
    };
  },
  methods: {
    onSettingClick() {
      this.loginPasswordVisible = true;
    },
    onEditClick() {
      this.changePhoneVisible = true;
    },
    //安全信息
    _getCustomerSafe() {
      getCustomerSafe()
        .then((res) => {
          const { data } = res;
          this.dataInfo = { ...this.dataInfo, ...data };
        })
        .catch((res) => {})
        .finally(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.component-container {
  width: 1040px;
  height: 650px;
  background-color: #ffffff;
  .title {
    text-align: left;
    height: 60px;
    line-height: 60px;
    margin-left: 20px;
    margin-right: 20px;
    font-size: 18px;
    border-bottom: 1px solid #eeeeee;
    color: #333333;
  }
  .account-box {
    display: flex;
    margin-left: 60px;
    margin-right: 20px;
    margin-top: 7px;
    height: 60px;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    .name {
      font-size: 14px;
      color: #333333;
    }
    .progress-box {
      width: 200px;
      margin-left: 20px;
      margin-right: 20px;
    }
    .security-box {
      font-size: 14px;
      color: #333333;
      .level {
        color: #ff8400;
      }
      .state {
        padding-left: 20px;
      }
    }
  }
  .item-box {
    height: 60px;
    margin-left: 60px;
    margin-right: 20px;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 50px;
    .item-left {
      display: flex;
      align-items: center;
      .item-img {
        padding-top: 5px;
        .image {
          width: 20px;
          height: 20px;
        }
      }
      .name {
        margin-left: 9px;
        font-size: 14px;
        color: #333333;
        margin-right: 30px;
      }
      .desc {
        font-size: 12px;
        color: #333333;
      }
    }
    .state {
      color: #1082ff;
      font-size: 14px;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
<style lang="scss">
.el-progress-bar__outer {
  border-radius: 0px;
  .el-progress-bar__inner {
    border-radius: 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/accountcenter/components/securitysettings.vue